import * as React from 'react';
import { addMonths } from 'date-fns';
import { useTheme } from '../../../theme';
import { getAllYears, getMonthsList, getTimestamp, isMonthAvailable } from '../../utils';
import { Month } from './Month/Month';
import { MonthHeader } from './Month/MonthHeader/MonthHeader';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../utils';
import classNames from 'classnames';
import { CdnIcon } from '@shared/ui';
export const MonthsWrapper = ({ initialDate, monthCount, monthsToScroll, monthBaseDateVariant = 'focused', onSelect, minDate, maxDate, selectedDates, monthsHeader, highlightedDates, getParentRef, onHover, hoverDates, frameless }) => {
    const [focusedDate, setFocusedDate] = React.useState(initialDate);
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    const headerRef = React.useRef(null);
    React.useEffect(() => {
        if (isMobile && getParentRef) {
            const parent = getParentRef().current;
            if (parent &&
                headerRef.current &&
                (parent.hasOwnProperty('scroll') || typeof parent.scroll === 'function')) {
                parent.scroll({
                    behavior: 'auto',
                    top: headerRef.current.offsetTop
                });
            }
        }
    }, []);
    const theme = useTheme('Datepicker').MonthsWrapperStyles, yearsArray = React.useMemo(() => getAllYears(getTimestamp(minDate), getTimestamp(maxDate)), [minDate, maxDate]);
    let minSelectedDatesTimestamp = Infinity, maxSelectedDatesTimestamp = 0;
    let minHoveredDatesTimestamp = Infinity, maxHoveredDatesTimestamp = 0;
    const setMonth = (date) => {
        setFocusedDate(date);
    };
    const setCurrentDate = (date, monthOffset = 0) => {
        let newDate = new Date(parseInt(date.toString()));
        if (monthOffset !== 0) {
            newDate = addMonths(newDate, monthOffset);
        }
        setMonth(newDate);
    };
    for (const selectedDate in selectedDates) {
        if (selectedDates.hasOwnProperty(selectedDate)) {
            const timestamp = parseInt(selectedDate);
            if (timestamp < minSelectedDatesTimestamp) {
                minSelectedDatesTimestamp = timestamp;
            }
            if (timestamp > maxSelectedDatesTimestamp) {
                maxSelectedDatesTimestamp = timestamp;
            }
        }
    }
    for (const hoverDateIndex in hoverDates) {
        if (hoverDates[hoverDateIndex]) {
            const timestamp = hoverDates[hoverDateIndex].getTime();
            if (timestamp < minHoveredDatesTimestamp) {
                minHoveredDatesTimestamp = timestamp;
            }
            if (timestamp > maxHoveredDatesTimestamp) {
                maxHoveredDatesTimestamp = timestamp;
            }
        }
    }
    const monthsToScrollValue = monthsToScroll !== null && monthsToScroll !== void 0 ? monthsToScroll : 1;
    /**
     * WEBSKY-8059:
     * для мобильного разрешения, если календарь реализован как лист, который скролится
     * выставляем базовую дату на минимальную дату, чтобы был доступ к "прошлым" датам
     */
    const monthListBaseDate = monthBaseDateVariant === 'focused' ? focusedDate !== null && focusedDate !== void 0 ? focusedDate : minDate : minDate;
    const renderMonth = (date, index, addRef) => {
        return (React.createElement(Month, { key: index, date: date, selectedDatesMap: selectedDates, minDateTimestamp: getTimestamp(minDate), maxDateTimestamp: getTimestamp(maxDate), minSelectedDateTimestamp: minSelectedDatesTimestamp, maxSelectedDateTimestamp: maxSelectedDatesTimestamp, minHoveredDateTimestamp: minHoveredDatesTimestamp, maxHoveredDateTimestamp: maxHoveredDatesTimestamp, highlightingDates: highlightedDates, onSelect: onSelect, onHover: onHover, monthHeader: React.createElement("div", { ref: addRef && focusedDate.getMonth && focusedDate.getMonth() === date.getMonth()
                    ? headerRef
                    : null },
                React.createElement(MonthHeader, { setCurrentMonth: setCurrentDate, years: yearsArray, monthIndex: index, currentDate: date, maxDate: maxDate, minDate: minDate })) }));
    };
    return (React.createElement("div", { className: classNames(theme.wrapper, { [theme.frameless]: frameless }) },
        React.createElement("nav", null,
            isMonthAvailable(focusedDate, -1, minDate, maxDate) && (React.createElement("div", { className: theme.nav_prev, onClick: () => setMonth(addMonths(focusedDate, -monthsToScrollValue)) },
                React.createElement(CdnIcon, { icon: 'Arrow/Chevron_left' }))),
            isMonthAvailable(focusedDate, monthCount, minDate, maxDate) && (React.createElement("div", { className: theme.nav_next, onClick: () => setMonth(addMonths(focusedDate, monthsToScrollValue)) },
                React.createElement(CdnIcon, { icon: 'Arrow/Chevron_right' })))),
        monthsHeader,
        React.createElement("div", { className: theme.monthsList }, getMonthsList(monthListBaseDate, monthCount).map((date, index) => renderMonth(date, index, isMobile)))));
};
